import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-recurring-payments',
  templateUrl: './recurring-payments.component.html',
  styleUrls: ['./recurring-payments.component.scss']
})
export class RecurringPaymentsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
